import { DropDownList, DropDownListProps } from '@progress/kendo-react-dropdowns';
import * as React from 'react';

type RollsRoyceVehicleDropDownProps = {
  value: string | null;
  onVehicleChange: (data: {
    value: string | null;
  }) => void;
} & DropDownListProps;

const RollsRoyceVehicleDropDown: React.FC<RollsRoyceVehicleDropDownProps> = ({
  value,
  onVehicleChange,
  ...selectProps
}) => {
  const vehicleOptions = [
    "8' Cargo Van",
    "12' Sprinter Van",
    "22' Straight Truck",
    "53' Dry Van Trailer",
    "53' Refrigerated Trailer (Reefer)",
    "53' Conestoga Trailer",
    "53' Curtainside Trailer",
    "53' Standard Flatbed Trailer",
    "53' Drop-Deck/Step-Deck Trailer",
    "53' Double Drop/Lowboy Trailer",
    "48' Extendable Drop-Deck Trailer",
    "48' Standard RGN Trailer",
    "62' Extendable RGN Trailer",
    "40' Bulk Tanker",
    "Air Freight",
  ];

  const defaultItem = 'Select Unit Type';

  return (
    <DropDownList
      data={vehicleOptions}
      value={value || defaultItem}
      onChange={(e) => {

        if (e.value !== defaultItem) {
          onVehicleChange({
            value: e.value
          });
        } else {
          onVehicleChange({
            value: null
          });
        }

        // Call original onChange if provided
        selectProps.onChange?.(e);
      }}
      defaultItem={defaultItem}
      {...selectProps}
    />
  );
};

export default RollsRoyceVehicleDropDown;
